import React from "react";
import { fileNameHelper } from "../amorg-common";
import { Icon } from "./icons/Icons";


type FileExtensionIconProps = {
    filename:string
}

export function FileExtensionIcon(props:FileExtensionIconProps):JSX.Element
{
    const ext = fileNameHelper.getSupportedFileExtension(props.filename);

    switch (ext) {
        case 'csv':
            return <Icon color="darkgray" name='file_csv' />;

        case 'xls':
        case 'xlsx':
            return <Icon color='green' name='file_excel' />;

        case 'mov':
        case 'mp4':
            return <Icon color='black' name='file_film' />;

        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            return <Icon color="blue" name='file_image' />;

        case 'pdf':
            return <Icon color="darkred" name='file_pdf' />;

        case 'txt':
        case 'rtf':
            return <Icon color="darkgrey" name='file_text' />;

        case 'doc':
        case 'docx':
            return <Icon color="darkblue" name='file_word' />;

        default:
            return <Icon name='file' />;
    }
}